import { init } from './init'
import { sendEvent } from './sendEvent'

export const GTM = {
  init,
  sendEvent,
}
